import { forwardRef, createElement } from 'react';

function IconCourses(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M11.441 3.441a1.25 1.25 0 01.983-.058l.135.058 9.598 4.799a.85.85 0 01.464.859l-.001 6.151a.75.75 0 11-1.5 0v-4.971L19 11.339V17.5c0 1.657-3.134 3-7 3-3.772 0-6.847-1.278-6.994-2.88L5 17.5v-6.162L1.842 9.76a.85.85 0 01-.421-1.042l.041-.098a.85.85 0 01.286-.325l.094-.055 9.598-4.799zm-4.942 8.647v5.395c.009.095.385.448 1.217.791C8.82 18.73 10.351 19 12 19c1.689 0 3.253-.284 4.359-.757.472-.203.822-.425 1.023-.629l.11-.117c.003-.003.005-.004.006-.003l.002.006v-5.411l-4.941 2.47a1.25 1.25 0 01-.983.058l-.135-.058-4.942-2.471zM12 4.838L3.677 8.999l8.322 4.162 8.323-4.162L12 4.838z",
    fill: "currentColor"
  }));
}

var Courses = /*#__PURE__*/forwardRef(IconCourses);

export default Courses;
//# sourceMappingURL=Courses.js.map
